import { Controller } from "stimulus"

export default class extends Controller {

    cBottom = document.getElementById("bottom-text");
    cTop = document.getElementById("top-text");
    topText = ["Top text here"];
    topVerticalDistance;
    bottomVerticalDistance;
    bottomText = ["Bottom text here"];
    startingPoint = 10;
    fontStyle = "Arial"
    height = 0
    ctx

    initialize() {
        this.cTop.style.width = '100%';
        this.cBottom.style.width = '100%';
        this.height = this.cTop.parentElement.offsetHeight * .15;
        this.topVerticalDistance = this.height * 0.9;
        this.bottomVerticalDistance = this.height * 0.375;
        this.cTop.style.height = this.height + 'px';
        this.cBottom.style.height = this.height + 'px';
        this.cTop.width = this.cTop.offsetWidth;
        this.cBottom.width = this.cBottom.offsetWidth;
        this.cTop.height = this.cTop.offsetHeight;
        this.cBottom.height = this.cBottom.offsetHeight;
        this.ctx = this.cTop.getContext("2d");

        this.ctx.fillStyle = "white";
        this.ctx.font = "bold " + this.height * 0.375 + "px " + this.fontStyle;
        this.ctx.fillText(this.topText[0], this.startingPoint, this.height * 0.9);
        this.ctx = this.cBottom.getContext("2d");

        this.ctx.fillStyle = "white";
        this.ctx.font = "bold " + this.height * 0.375 + "px " + this.fontStyle;
        this.ctx.fillText(this.bottomText[0], this.startingPoint, this.height * 0.375);

        this.instagram();
        if (document.getElementById("video")) {
            document.getElementById("video").addEventListener("loadedmetadata", this.updateDuration, false);
            document.getElementById("video").addEventListener("timeupdate", this.updateProgress, false);
            document.getElementById("video").addEventListener("timeupdate", this.updateDuration, false);
        } else {

        }
        window.addEventListener('resize', () => {
            this.startingPoint = 10;
            this.cTop.style.width = '100%';
            this.cBottom.style.width = '100%';
            this.cTop.width = this.cTop.offsetWidth;
            this.cBottom.width = this.cBottom.offsetWidth;

            let width = document.getElementById("image-container").clientWidth;
            document.getElementById("image-container").style.height = String(width) + "px";
            this.height = this.cTop.parentElement.offsetHeight * .15;
            if (document.getElementById("image-container").classList.contains('aspect-ratio-square')) {
                document.getElementById("image-container").style.height = String(width) + "px";
            } else if (document.getElementById("image-container").classList.contains('aspect-ratio-16/9')) {
                document.getElementById("image-container").style.height = String(width * 9 / 16) + "px";
            } else {
                document.getElementById("image-container").style.height = String(width * 3 / 4) + "px";
            }
            let align = "left";
            if (document.getElementById("text-right").parentElement.classList.contains("border-green-500")) {
                align = "end";
                this.startingPoint = this.cTop.width - 10;
            } else if (document.getElementById("text-center").parentElement.classList.contains("border-green-500")) {
                align = "center";
                this.startingPoint = this.cTop.width / 2;
            }
            this.topVerticalDistance = this.height * 0.9;
            this.bottomVerticalDistance = this.height * 0.375;
            this.cTop.style.height = this.height + 'px';
            this.cBottom.style.height = this.height + 'px';
            this.cTop.height = this.cTop.offsetHeight;
            this.cBottom.height = this.cBottom.offsetHeight;
            this.ctx = this.cTop.getContext("2d");
            this.ctx.fillStyle = document.getElementById("top-color").value;
            this.ctx.font = "bold " + this.height * 0.375 + "px " + this.fontStyle;
            this.ctx.textAlign = align;
            this.ctx.clearRect(0, 0, this.cTop.width, this.cTop.height);
            for (let i = this.topText.length - 1; i >= 0; i--) {
                this.ctx = this.cTop.getContext("2d");
                this.ctx.fillText(this.topText[i], this.startingPoint, this.topVerticalDistance);
                this.topVerticalDistance -= this.height * 0.425;
            }
            this.ctx = this.cBottom.getContext("2d");
            this.ctx.textAlign = align;
            this.ctx.fillStyle = document.getElementById("bottom-color").value;
            this.ctx.font = "bold " + this.height * 0.375 + "px " + this.fontStyle;
            this.ctx.clearRect(0, 0, this.cBottom.width, this.cBottom.height);
            for (let i = 0; i < this.bottomText.length; i++) {
                this.ctx = this.cBottom.getContext("2d");
                this.ctx.fillText(this.bottomText[i], this.startingPoint, this.bottomVerticalDistance);
                this.bottomVerticalDistance += this.height * 0.425;
            }
        }, true);
    }

    changeTopText() {
        this.topVerticalDistance = this.height * 0.9;
        let target = document.getElementById('image_top');
        this.ctx = this.cTop.getContext("2d");
        var width = this.cTop.clientWidth - 20;
        var indices = [0];
        var value = target.value;
        for (var i = 0; i < target.value.length; i++) {
            if (target.value[i] === '\n') indices.push(i);
        }
        indices.push(target.value.length - 1);
        for (i = 0; i < indices.length - 1; i++) {
            if (this.ctx.measureText(value.substring(indices[i], indices[i + 1])).width > width) {
                let index = target.value.lastIndexOf(" ", indices[i + 1]);
                if (index > -1) {
                    if (index < indices[i + 1]) {
                        target.value = target.value.substring(0, index + 1) + '\n' + target.value.substring(index + 1);
                    } else if (index == indices[i + 1]) {
                        let j = index - 1;
                        while (target.value[j] == ' ') j -= 1;
                        target.value = target.value.substring(0, j + 1) + '\n' + target.value.substring(index + 1);
                    } else {
                        target.value = target.value.substring(0, indices[i + 1]) + target.value.substring(index + 1);
                    }
                }
            }
        }
        this.topText = target.value.split('\n');
        if (this.topText.length > 2) {
            target.value = target.value.substr(0, (this.topText[0].length + this.topText[1].length + 1));
            this.topText = target.value.split('\n');
        }
        this.ctx.clearRect(0, 0, this.cTop.width, this.cTop.height);
        for (let i = this.topText.length - 1; i >= 0; i--) {
            this.changeCanvasText(this.topText[i], this.cTop, this.topVerticalDistance);
            this.topVerticalDistance -= this.height * 0.425;
        }
        target.rows = this.topText.length;
    }

    changeBottomText() {
        this.ctx = this.cBottom.getContext("2d");
        let target = document.getElementById('image_bottom');
        var width = this.cBottom.clientWidth - this.height * 0.375;
        var indices = [0];
        var value = target.value;
        for (var i = 0; i < target.value.length; i++) {
            if (target.value[i] === '\n') indices.push(i);
        }
        indices.push(target.value.length - 1);
        for (i = 0; i < indices.length - 1; i++) {
            if (this.ctx.measureText(value.substring(indices[i], indices[i + 1])).width > width) {
                let index = target.value.lastIndexOf(" ", indices[i + 1]);
                if (index > -1) {
                    if (index < indices[i + 1]) {
                        target.value = target.value.substring(0, index + 1) + '\n' + target.value.substring(index + 1);
                    } else if (index == indices[i + 1]) {
                        let j = index - 1;
                        while (target.value[j] == ' ') j -= 1;
                        target.value = target.value.substring(0, j + 1) + '\n' + target.value.substring(index + 1);
                    } else {
                        target.value = target.value.substring(0, indices[i + 1]) + target.value.substring(index + 1);
                    }
                }
            }
        }
        this.bottomText = target.value.split('\n');
        if (this.bottomText.length > 2) {
            target.value = target.value.substr(0, (this.bottomText[0].length + this.bottomText[1].length + 1));
            this.bottomText = target.value.split('\n');
        }
        this.bottomVerticalDistance = this.height * 0.375;

        this.ctx.clearRect(0, 0, this.cTop.width, this.cTop.height);
        for (let i = 0; i < this.bottomText.length; i++) {
            this.changeCanvasText(this.bottomText[i], this.cBottom, this.bottomVerticalDistance);
            this.bottomVerticalDistance += this.height * 0.425;
        }
        target.rows = this.bottomText.length;
    }

    changeCanvasText(text, place, verticalDistance) {
        this.ctx = place.getContext("2d");
        this.ctx.fillText(text, this.startingPoint, verticalDistance);
    }

    align(alignment) {
        this.topVerticalDistance = this.height * 0.9;
        this.bottomVerticalDistance = this.height * 0.375;
        this.ctx = this.cTop.getContext("2d");
        this.ctx.clearRect(0, 0, this.cTop.width, this.cTop.height);
        this.ctx.textAlign = alignment;
        for (let i = this.topText.length - 1; i >= 0; i--) {
            this.changeCanvasText(this.topText[i], this.cTop, this.topVerticalDistance);
            this.topVerticalDistance -= this.height * 0.425;
        }
        this.ctx = this.cBottom.getContext("2d");
        this.ctx.clearRect(0, 0, this.cBottom.width, this.cBottom.height);
        this.ctx.textAlign = alignment;
        for (let i = 0; i < this.bottomText.length; i++) {
            this.changeCanvasText(this.bottomText[i], this.cBottom, this.bottomVerticalDistance);
            this.bottomVerticalDistance += this.height * 0.425;
        }
    }

    alignLeft() {
        document.getElementById("meme_alignment").value = "left";
        this.startingPoint = 10;
        this.align("start");
        document.getElementById("text-left").parentElement.classList.add("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("text-center").parentElement.classList.remove("border", "border-green-500", "-m-px", "border-l", "text-green-500");
        document.getElementById("text-right").parentElement.classList.remove("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("text-center").parentElement.classList.add("border-r");
    }

    alignCenter() {
        document.getElementById("meme_alignment").value = "center";
        this.startingPoint = this.cTop.width / 2;
        this.align("center");
        document.getElementById("text-left").parentElement.classList.remove("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("text-center").parentElement.classList.add("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("text-right").parentElement.classList.remove("border", "border-green-500", "-m-px", "text-green-500");
    }

    alignRight() {
        document.getElementById("meme_alignment").value = "right";
        this.startingPoint = this.cTop.width - 10;
        this.align("end");
        document.getElementById("text-left").parentElement.classList.remove("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("text-center").parentElement.classList.remove("border", "border-green-500", "-m-px", "border-r", "text-green-500");
        document.getElementById("text-right").parentElement.classList.add("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("text-center").parentElement.classList.add("border-l");
    }

    instagram() {
        document.getElementById("meme_aspect_ratio").value = "1/1";
        let width = document.getElementById("image-container").clientWidth;
        document.getElementById("image-container").style.height = String(width) + "px";
        document.getElementById("image-container").classList.remove('aspect-ratio-16/9');
        document.getElementById("image-container").classList.remove('aspect-ratio-4/3');
        document.getElementById("image-container").classList.add('aspect-ratio-square');
        document.getElementById("1:1").parentElement.classList.add("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("16:9").parentElement.classList.remove("border", "border-green-500", "-m-px", "border-l", "text-green-500");
        document.getElementById("4:3").parentElement.classList.remove("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("16:9").parentElement.classList.add("border-r");
    }

    youtube() {
        document.getElementById("meme_aspect_ratio").value = "16/9";
        let width = document.getElementById("image-container").clientWidth;
        document.getElementById("image-container").style.height = String(width * 9 / 16) + "px";
        document.getElementById("image-container").classList.add('aspect-ratio-16/9');
        document.getElementById("image-container").classList.remove('aspect-ratio-4/3');
        document.getElementById("image-container").classList.remove('aspect-ratio-square');
        document.getElementById("1:1").parentElement.classList.remove("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("16:9").parentElement.classList.add("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("4:3").parentElement.classList.remove("border", "border-green-500", "-m-px", "text-green-500");
    }

    facebook() {
        document.getElementById("meme_aspect_ratio").value = "4/3";
        let width = document.getElementById("image-container").clientWidth;
        document.getElementById("image-container").style.height = String(width * 3 / 4) + "px";
        document.getElementById("image-container").classList.remove('aspect-ratio-16/9');
        document.getElementById("image-container").classList.add('aspect-ratio-4/3');
        document.getElementById("image-container").classList.remove('aspect-ratio-square');
        document.getElementById("1:1").parentElement.classList.remove("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("16:9").parentElement.classList.remove("border", "border-green-500", "-m-px", "border-r", "text-green-500");
        document.getElementById("4:3").parentElement.classList.add("border", "border-green-500", "-m-px", "text-green-500");
        document.getElementById("16:9").parentElement.classList.add("border-l");
    }

    afterImageTemplate() {
        document.getElementById("meme_meme_template").value = "black";
        this.cTop.classList.add("bg-black");
        this.cBottom.classList.add("bg-black");
        if (!document.getElementById("video")) {}
        document.getElementById("after-image").classList.add("border-2", "border-green-500");
        document.getElementById("on-image").classList.remove("border-2", "border-green-500");
    }

    onImageTemplate() {
        document.getElementById("meme_meme_template").value = "transparent";
        this.cTop.classList.remove("bg-black");
        this.cBottom.classList.remove("bg-black");
        document.getElementById("after-image").classList.remove("border-2", "border-green-500");
        document.getElementById("on-image").classList.add("border-2", "border-green-500");
    }

    changeFontStyle(event) {
        const fillStyle = event.target.value.split('-');
        this.topVerticalDistance = this.height * 0.9;
        this.bottomVerticalDistance = this.height * 0.375;
        this.fontStyle = fillStyle[0];
        this.ctx = this.cTop.getContext("2d");
        this.ctx.font = "bold " + this.height * 0.375 + "px " + this.fontStyle;
        this.ctx.clearRect(0, 0, this.cTop.width, this.cTop.height);
        for (let i = this.topText.length - 1; i >= 0; i--) {
            this.changeCanvasText(this.topText[i], this.cTop, this.topVerticalDistance);
            this.topVerticalDistance -= this.height * 0.425;
        }
        this.ctx = this.cBottom.getContext("2d");
        this.ctx.font = "bold " + this.height * 0.375 + "px " + this.fontStyle;
        this.ctx.clearRect(0, 0, this.cBottom.width, this.cBottom.height);
        for (let i = 0; i < this.bottomText.length; i++) {
            this.changeCanvasText(this.bottomText[i], this.cBottom, this.bottomVerticalDistance);
            this.bottomVerticalDistance += this.height * 0.425;
        }
    }

    changeTopTextColor(event) {
        this.topVerticalDistance = this.height * 0.9;
        this.ctx = this.cTop.getContext("2d");
        this.ctx.fillStyle = event.target.value;
        this.ctx.clearRect(0, 0, this.cTop.width, this.cTop.height);
        for (let i = this.topText.length - 1; i >= 0; i--) {
            this.changeCanvasText(this.topText[i], this.cTop, this.topVerticalDistance);
            this.topVerticalDistance -= this.height * 0.425;
        }
    }

    changeBottomTextColor(event) {
        this.bottomVerticalDistance = this.height * 0.375;
        this.ctx = this.cBottom.getContext("2d");
        this.ctx.fillStyle = event.target.value;
        this.ctx.clearRect(0, 0, this.cBottom.width, this.cBottom.height);
        for (let i = 0; i < this.bottomText.length; i++) {
            this.changeCanvasText(this.bottomText[i], this.cBottom, this.bottomVerticalDistance);
            this.bottomVerticalDistance += this.height * 0.425;
        }
    }


    updateDuration() {
        var video = document.getElementById("video");
        var duration = document.getElementById("duration");
        var minutes = Math.floor(video.currentTime / 60);
        var seconds = Math.floor(video.currentTime) % 60;
        var currentTime = minutes + ":" + seconds;
        minutes = Math.floor(video.duration / 60);
        seconds = Math.floor(video.duration) % 60;
        var videoDuration = minutes + ":" + seconds;
        duration.innerHTML = currentTime + "/" + videoDuration;
    }

    updateProgress() {
        var progress = document.getElementById("progress");
        var video = document.getElementById("video");
        var value = 0;
        if (video.currentTime > 0) {
            value = Math.floor((100 / video.duration) * video.currentTime);
        }
        progress.style.width = value + "%";
        if (value == 100) {
            var playpause = document.getElementById("playpause");
            playpause.innerHTML = '<svg width="24px" height="24px" viewBox="0 0 163.861 163.861" class="block mx-auto"><g><path d="M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z"/></g></svg>';
        }
    }

    togglePlayPause() {
        var playpause = document.getElementById("playpause");
        var video = document.getElementById("video");
        if (video.paused || video.ended) {
            playpause.innerHTML = '<svg height="24px" viewBox="-45 0 327 327" width="24px"  class="block mx-auto"><path d="m158 0h71c4.417969 0 8 3.582031 8 8v311c0 4.417969-3.582031 8-8 8h-71c-4.417969 0-8-3.582031-8-8v-311c0-4.417969 3.582031-8 8-8zm0 0"/><path d="m8 0h71c4.417969 0 8 3.582031 8 8v311c0 4.417969-3.582031 8-8 8h-71c-4.417969 0-8-3.582031-8-8v-311c0-4.417969 3.582031-8 8-8zm0 0"/></svg>';
            video.play();
        } else {
            playpause.innerHTML = '<svg width="24px" height="24px" viewBox="0 0 163.861 163.861" class="block mx-auto"><g><path d="M34.857,3.613C20.084-4.861,8.107,2.081,8.107,19.106v125.637c0,17.042,11.977,23.975,26.75,15.509L144.67,97.275c14.778-8.477,14.778-22.211,0-30.686L34.857,3.613z"/></g></svg>';
            video.pause();
        }
    }

    toggleAudio() {
        var video = document.getElementById("video");
        var audio = document.getElementById("audio");
        video.muted = !video.muted;
        if (video.muted) {
            audio.innerHTML = '<svg version="1.1" height="24px" width="24px" viewBox="0 0 384 384" style="enable-background:new 0 0 384 384;" xml:space="preserve"><g><g><g><path d="M288,192c0-37.653-21.76-70.187-53.333-85.867v47.147l52.373,52.373C287.68,201.173,288,196.587,288,192z"/><path d="M341.333,192c0,20.053-4.373,38.933-11.52,56.32l32.32,32.32C376,254.08,384,224,384,192 c0-91.307-63.893-167.68-149.333-187.093V48.96C296.32,67.307,341.333,124.373,341.333,192z"/><polygon points="192,21.333 147.413,65.92 192,110.507"/><path d="M27.2,0L0,27.2L100.8,128H0v128h85.333L192,362.667V219.2l90.773,90.773c-14.293,10.987-30.4,19.84-48.107,25.173V379.2c29.333-6.72,56.107-20.16,78.613-38.613L356.8,384l27.2-27.2l-192-192L27.2,0z"/></g></g></g></svg>';
        } else {
            audio.innerHTML = '<svg version="1.1" viewBox="0 0 384 384" style="enable-background:new 0 0 384 384;" height="24px" width="24px"><g><g><g><path d="M288,192c0-37.653-21.76-70.187-53.333-85.867v171.84C266.24,262.187,288,229.653,288,192z"/><polygon points="0,128 0,256 85.333,256 192,362.667 192,21.333 85.333,128"/><path d="M234.667,4.907V48.96C296.32,67.307,341.333,124.373,341.333,192S296.32,316.693,234.667,335.04v44.053C320.107,359.68,384,283.413,384,192S320.107,24.32,234.667,4.907z"/></g></g></g></svg>';
        }
    }

    processVideo(event) {
        if (document.getElementById("image_top").checkValidity() && document.getElementById("image_bottom").checkValidity()) {
            event.target.innerText = "Processing";
        }
    }
}